import type { ReactNode } from 'react';
import { HomeOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

import { colorConstants } from 'config/colorConstants';

export type AppBreadcrumbItem = {
    label: ReactNode;
    to?: string;
};

type AppBreadcrumbProps = {
    items: AppBreadcrumbItem[];
    homeTo?: string;
    showHomeIcon?: boolean;
};

const AppBreadcrumb = ({ items, homeTo = '/', showHomeIcon = true }: AppBreadcrumbProps) => (
    <nav className="flex items-center" aria-label="Breadcrumb">
        {showHomeIcon ? (
            <Link to={homeTo} className="flex items-center text-black/50 hover:text-black/65" aria-label="Home">
                <HomeOutlined className="text-[12px]" />
            </Link>
        ) : null}
        {items.map((item, index) => {
            const isLast = index === items.length - 1;
            const showSeparator = showHomeIcon || index > 0;
            const itemClassName = isLast
                ? 'text-[12px] font-medium leading-[22px] text-fontColor'
                : 'text-[12px] font-normal leading-[22px] text-black/50';

            return (
                <span key={`${String(item.label)}-${index}`} className="inline-flex items-center">
                    {showSeparator ? (
                        <span
                            className="px-2 text-[10px] leading-[22px]"
                            style={{ color: colorConstants.breadcrumbSlash }}
                            aria-hidden
                        >
                            /
                        </span>
                    ) : null}
                    {!isLast && item.to ? (
                        <Link to={item.to} className={`${itemClassName} hover:text-black/65`}>
                            {item.label}
                        </Link>
                    ) : (
                        <span className={itemClassName}>{item.label}</span>
                    )}
                </span>
            );
        })}
    </nav>
);

export default AppBreadcrumb;
